import React, {useEffect} from 'react';
import {StyleSheet, View, Platform} from 'react-native';
import useWindowDimensionsSafe from 'src/Modules/Native/useWindowDimensionsSafe';
import {PanGestureHandler} from 'react-native-gesture-handler';
import Animated, {
  runOnJS,
  useAnimatedGestureHandler,
  useAnimatedStyle,
  useSharedValue,
  withSpring,
} from 'react-native-reanimated';
import {useSelector} from 'react-redux';
import {mmkvStorage} from '../../Utils/mmkvStorage';

const topPadding = 140;
const bottomPadding = 100;
const sidePadding = 40;

const DraggableButton = ({children, size}) => {
  const {width, height} = useWindowDimensionsSafe();
  const snapPointsX = [0, width - size - sidePadding];
  const snapPointsY = [0, height - size - topPadding - bottomPadding];

  const translateX = useSharedValue(-100);
  const translateY = useSharedValue(-100);

  console.log({translateX, translateY});

  const handleDone = (xActivated, yActivated) => {
    console.log('setting defaults', {xActivated, yActivated});
    mmkvStorage.set('xDefault', xActivated ? '1' : '0');
    mmkvStorage.set('yDefault', yActivated ? '1' : '0');
  };

  const onGestureEvent = useAnimatedGestureHandler({
    onStart: (_event, ctx) => {
      console.log('hi');
      ctx.x = translateX.value;
      ctx.y = translateY.value;
    },
    onActive: ({translationX, translationY}, ctx) => {
      translateX.value = ctx.x + translationX;
      translateY.value = ctx.y + translationY;
    },
    onEnd: async (onEndEvent) => {
      console.log({onEndEvent});
      const {absoluteX, absoluteY, velocityX, velocityY} = onEndEvent;
      const xActivated = absoluteX + 5 * velocityX > width / 2;
      const yActivated = absoluteY + 5 * velocityY > height / 2;
      const snapPointX = !!xActivated ? snapPointsX[1] : snapPointsX[0];
      const snapPointY = !!yActivated ? snapPointsY[1] : snapPointsY[0];

      console.log({snapPointX, snapPointY});

      translateX.value = withSpring(snapPointX, {velocity: velocityX * 2});
      translateY.value = withSpring(snapPointY, {velocity: velocityY * 2});

      if (Platform.OS != 'web') {
        runOnJS(handleDone)(xActivated, yActivated);
      } else {
        console.log('setting defaults', {xActivated, yActivated});
        mmkvStorage.set('xDefault', xActivated ? '1' : '0');
        mmkvStorage.set('yDefault', yActivated ? '1' : '0');
      }

      // runOnJS(setDefaults(xActivated, yActivated));
    },
  });

  const style = useAnimatedStyle(() => ({
    width: size,
    aspectRatio: 1,
    position: 'absolute',
    top: 0,
    transform: [{translateX: translateX.value}, {translateY: translateY.value}],
  }));

  useEffect(() => {
    const xDefault = 1 * (mmkvStorage.getString('xDefault') || '1');
    const yDefault = 1 * (mmkvStorage.getString('yDefault') || '1');
    console.log('initial mount draggable buttom', {xDefault, yDefault});
    translateX.value = snapPointsX[xDefault];
    translateY.value = snapPointsY[yDefault];
  }, [size, width]);

  console.log({size});

  // testing if a modal is open
  const isModal = useSelector(
    (state) =>
      [
        'FoxShop',
        'PhotoVideoCamera',
        'PlayerTreasureChallenges',
        'PlayerTrivia',
        'QuestionFeedback',
        'LoginPage',
        'LoginModal',
      ]?.includes?.(state.current_screen?.currentScreen) ||
      state.current_screen?.currentScreen?.includes('Modal') ||
      state.current_screen?.isDrawerOpen,
  );

  if (isModal) {
    return <View></View>;
  }

  return (
    // eslint-disable-next-line no-use-before-define
    <View style={styles.container} pointerEvents={'box-none'}>
      <PanGestureHandler
        onGestureEvent={Platform.OS != 'web' ? onGestureEvent : null}>
        <Animated.View style={style}>{children}</Animated.View>
      </PanGestureHandler>
    </View>
  );
};

export default DraggableButton;

const styles = StyleSheet.create({
  container: {
    flex: 1,
    position: 'absolute',
    top: topPadding,
    left: sidePadding / 2,
    bottom: bottomPadding,
    right: sidePadding / 2,
  },
});
